var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.055,
    height: 36,
    viewBox: "0 0 46.055 36"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "quote_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    className: "quote_svg__from"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    className: "quote_svg__to"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#quote_svg__a)",
    d: "M46.421 41.334H31.1a2.3 2.3 0 01-2.3-2.3V26.207q0-8.353 3.527-13.185 2.091-2.865 9.99-7.384a2.3 2.3 0 013.142.855l.026.047 2.155 3.983a2.3 2.3 0 01-.881 3.1 22.107 22.107 0 00-5.342 3.762 9.807 9.807 0 00-2.221 5.712h7.224a2.3 2.3 0 012.3 2.3V39.03a2.3 2.3 0 01-2.3 2.3zm-26.132 0H4.969a2.3 2.3 0 01-2.3-2.3V26.207q0-8.353 3.527-13.185 2.091-2.865 9.99-7.384a2.3 2.3 0 013.142.855l.026.047 2.156 3.983a2.3 2.3 0 01-.881 3.1 22.107 22.107 0 00-5.342 3.762 9.807 9.807 0 00-2.221 5.712h7.225a2.3 2.3 0 012.3 2.3V39.03a2.3 2.3 0 01-2.3 2.3z",
    transform: "translate(-2.667 -5.334)"
  })));
}
export default SvgQuote;